// extracted by css-extract-rspack-plugin
export default {"popup":"FilterCategories_popup__RJf69"};